import { render } from "./PrivacyContest.vue?vue&type=template&id=a5cf7516&scoped=true&lang=pug"
import script from "./PrivacyContest.vue?vue&type=script&lang=js"
export * from "./PrivacyContest.vue?vue&type=script&lang=js"

import "./PrivacyContest.vue?vue&type=style&index=0&id=a5cf7516&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/jobs/ohm-landing/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5cf7516"]])

export default __exports__